import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./appAdminSidebar.css";
import axios from "../../axios/axios";

import moment from "moment";


const AppSidebar = ({ menuToggle, setMenuToggle }) => {

  const [dropdownMenu, setDropdownMenu] = useState(false);
  const [iconToggle, seticonToggle] = useState(true);

  const date = new Date();
  const [open, setOpen] = useState();


  const sideMenu = (index) => {
    console.log("You have", index);

    setDropdownMenu(open != index ? true : !dropdownMenu);
    setOpen(index);
  };

  const Array = [
    {
      Title: "Dashboard",
      NavLink: "/dashboard"
    },
    {
      Title: "Leads",
      NavLink: "/student"
    },
    {
      Title: "Report",
      NavLink: "/resport"
    },

  ]

  return (
    <>
      <div className="app-admin-sidebar"

      >
        {Array?.map((d, index) => (<div>
          <NavLink
            to={d?.NavLink}
            className="mr-2 ml-2"
            activeclassName="active"
          >
            <div className="">{d?.Title}</div>
          </NavLink>
        </div>))}

      </div>
    </>
  );
};

export default AppSidebar;
